import { useCallback } from 'react';
import { updatePermissions } from 'src/components/pages/Case/Case.slice';
import { CasePermissionsType } from 'src/types';
import { AccessActionEnum } from '../components/AccessItem/AccessItem';

type UsePermissionLogicProps = {
  permissions: CasePermissionsType[];
  handleSetPermissions: (
    permissions: CasePermissionsType[],
    action: AccessActionEnum,
  ) => void;
};

export const usePermissionLogic = ({
  permissions,
  handleSetPermissions,
}: UsePermissionLogicProps) => {
  const updatePermissionsWithConsistency = useCallback(
    (permissionsToUpdate: CasePermissionsType[], action: AccessActionEnum) => {
      const updatedPermissions = updatePermissions(
        permissions,
        permissionsToUpdate,
        action,
      );

      // If the updated permissions differ from what we're trying to set,
      // we need to handle the consistency logic
      if (action === AccessActionEnum.ADD) {
        const newPermissions = updatedPermissions.filter(
          (permission) => !permissions.includes(permission),
        );
        if (newPermissions.length > 0) {
          handleSetPermissions(newPermissions, AccessActionEnum.ADD);
        }
      } else {
        const removedPermissions = permissions.filter(
          (permission) => !updatedPermissions.includes(permission),
        );
        if (removedPermissions.length > 0) {
          handleSetPermissions(removedPermissions, AccessActionEnum.REMOVE);
        }
      }
    },
    [permissions, handleSetPermissions],
  );

  return {
    updatePermissionsWithConsistency,
  };
};
